import { useTranslation } from "react-i18next";
import { useCreatePageDialogController } from "../hooks/useCreatePageDialogController";
import { PageSettingsDialog } from "./PageSettingsDialog";

type CreatePageDialogProps = {
    open: boolean;
    onClose: () => void;
    onCreatePage: (payload: {
        title: string;
        description?: string;
        downloadOnlyOnSsqValidated?: boolean;
        allowedRoles: string[];
        url?: string;
        sectors?: string[];
        score?: string[];
        entity?: string[];
    }) => void;
    isCreating: boolean;
    pageType?: "CMS" | "PDF";
};

export const CreatePageDialog = (props: CreatePageDialogProps) => {
    const { open, onClose, onCreatePage, isCreating, pageType = "CMS" } = props;
    const { t } = useTranslation();

    const controller = useCreatePageDialogController({
        onCreatePage,
        onClose,
        isCreating,
        pageType,
    });

    return (
        <PageSettingsDialog
            open={open}
            pageType={pageType}
            settingsTitle={controller.newPageTitle}
            settingsDescription={controller.newPageDescription}
            settingsUrl={controller.url}
            settingsRoles={controller.selectedRoles}
            settingsActive={true}
            settingsSectorIds={controller.selectedSectorIds}
            settingsScore={controller.selectedScore}
            settingsEntity={controller.selectedEntity}
            settingsDownloadOnlyOnSsqValidated={controller.downloadOnlyOnSsqValidated}
            allSectors={controller.sectorOptions}
            sectorOptions={controller.sectorOptions}
            selectedSectorOptions={controller.selectedSectorOptions}
            onSectorInputChange={controller.setSectorInput}
            scores={controller.scores}
            disabled={isCreating}
            showStatusToggle={false}
            urlError={controller.isUrlInvalid}
            urlHelperText={
                controller.isUrlInvalid ?
                    t("settings.cms.pages.create_dialog.url_invalid", "URL is invalid or reserved")
                :   ""
            }
            saveDisabled={!controller.canCreate}
            saveButtonLabel={t("settings.cms.pages.create_dialog.create", "Create")}
            onChangeTitle={controller.setNewPageTitle}
            onChangeDescription={controller.setNewPageDescription}
            onChangeUrl={controller.setUrl}
            onChangeActive={() => {}}
            onChangeRoles={controller.setSelectedRoles}
            onChangeSectorIds={controller.setSelectedSectorIds}
            onChangeScore={controller.setSelectedScore}
            onChangeEntity={controller.setSelectedEntity}
            onChangeDownloadOnlyOnSsqValidated={controller.setDownloadOnlyOnSsqValidated}
            onClose={controller.handleClose}
            onSave={controller.handleCreate}
            saving={isCreating}
        />
    );
};
